import React, { PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import { Button } from 'reactstrap';
import ChevronRightIcon from 'mdi-react/ChevronRightIcon';
import BellRingOutlineIcon from 'mdi-react/BellRingOutlineIcon';
import { subscribeUnread, clearUnread, formatUnread } from '../../../shared/functions/unreadPoller';
import {
  KINDS, avatarUrl, userIcon, unseenReplies,
} from '../../../shared/functions/feedKinds';
import trackEvent from '../../../shared/functions/trackEvent';

const notifsIcon = `${process.env.PUBLIC_URL}/img/notifications.svg`;

class TopbarNotification extends PureComponent {
  state = {
    unread: 0,
    collapse: false,
    notifications: [],
    unseenByKind: {},
  };

  componentDidMount = () => {
    this.unsubscribe = subscribeUnread(({ notifications, unreadNotifications, unseenByKind }) => {
      this.setState({ notifications, unread: unreadNotifications, unseenByKind });
    });
  };

  componentWillUnmount = () => {
    if (this.unsubscribe) this.unsubscribe();
  };

  // Opening the dropdown no longer marks everything read: the count stays until
  // the user actually opens a notification or the full list. Each opening is
  // tracked with the label that was showing, to see whether the pulse draws
  // the click; closing (also what markRead does) is not.
  toggle = () => {
    const { collapse, unseenByKind } = this.state;
    if (!collapse) {
      const label = unseenReplies(unseenByKind);
      trackEvent('bell_opened', { label: label ? label.kind : 'none', count: label ? label.count : 0 });
    }
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  // An entry was opened or the whole center asked for: nothing is unseen any
  // more. The centre stamps its own watermark when it loads; an entry click
  // leaves the page, so the same stamp is posted from here.
  markRead = () => {
    this.toggle();
    clearUnread('notifications');
    axios.post('/conversations/notifications/seen').catch(() => {});
    axios.post('/conversations/notifications/unread/remove').catch(() => {});
  };

  render() {
    const {
      collapse, notifications, unread, unseenByKind,
    } = this.state;
    // New replies pulse on the bell; the badge still counts everything else.
    const label = unseenReplies(unseenByKind);

    return (
      <div className="topbar__collapse">
        <button
          className={`topbar__btn topbar__btn--new${label ? ' topbar__btn--labelled topbar__btn--pulse' : ''}`}
          type="button"
          onClick={this.toggle}
        >
          <div className="topbar__btn-icon-wrapper">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="18" cy="18" r="17.5" stroke="#8D9AA1" fill="none" />
            </svg>
            <img src={notifsIcon} alt="notifications" className="topbar__btn-icon-image" />
          </div>
          {unread > 0 && <span className="topbar__btn-count">{formatUnread(unread)}</span>}
          {label && <span className="topbar__btn-label topbar__btn-label--reply">{label.text}</span>}
        </button>
        {collapse && (
          <>
            <button className="topbar__back" type="button" onClick={this.toggle} />
            <span className="topbar__collapse-arrow" />
            <div className="topbar__collapse-content">
              <div className="topbar__collapse-title-wrap">
                <p className="topbar__collapse-title">Notifications</p>
              </div>
              {(!notifications || notifications.length === 0) && (
                <div className="topbar__collapse-empty">
                  <BellRingOutlineIcon />
                  <p className="topbar__collapse-empty-title">Nothing new yet</p>
                  <p className="topbar__collapse-empty-text">
                    This is where you will hear that an investor replied to your emails, viewed your profile,
                    opened your deck or accepted your invitation. Check back often to see your traction as it happens.
                  </p>
                </div>
              )}
              {notifications && notifications.map((item) => {
                const kind = KINDS[item.kind] || KINDS.activity;
                return (
                  <div key={item.id}>
                    <div className="topbar__collapse-item-divider
                      d-flex flex-row align-items-center justify-content-center"
                    >
                      <svg width="221" height="2" viewBox="0 0 221 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 1C10.5 1 220.5 1 220.5 1" stroke="#EDEFF2" />
                      </svg>
                      <span className="topbar__collapse-date" title={moment(item.datetime).format('LLL')}>
                        {moment(item.datetime).fromNow()}
                      </span>
                    </div>
                    <Link
                      className={`topbar__collapse-item topbar__collapse-item--feed${item.isNew
                        ? ' topbar__collapse-item--new' : ''}`}
                      to={item.link || '/notifications'}
                      onClick={this.markRead}
                    >
                      <div className="topbar__collapse-img-wrap">
                        <img
                          className="topbar__collapse-img"
                          src={avatarUrl(item.actor)}
                          onError={(e) => { e.target.onerror = null; e.target.src = userIcon; }}
                          alt="user"
                        />
                      </div>
                      <p className="topbar__collapse-message">
                        <span className="topbar__collapse-name">{item.actor.name}</span>
                        <span className={`feed-badge ${kind.badge}`}>{kind.label}</span>
                        <span className="topbar__collapse-preview">{item.text || item.title}</span>
                      </p>
                    </Link>
                  </div>
                );
              })}
              <Link to="/notifications" onClick={this.markRead}>
                <Button
                  className="rounded icon icon--right icon--blue center-block topbar__action-btn"
                  color="primary"
                  size="sm"
                >
                  See all notifications
                  <ChevronRightIcon />
                </Button>
              </Link>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default withRouter(TopbarNotification);
